import React from 'react';
import DidYouMean from '../../coveo/components/did-you-mean';

export type ErrorProps = {
  errorMessage: string;
  noResultsMessage: string;
  noResultsKeywordMessage: string;
  noResultsAdditionalMessage?: string;
  keyword?: string;
  showError?: boolean;
  withDidYouMean?: boolean;
};

function Error({
  errorMessage,
  noResultsMessage,
  noResultsKeywordMessage,
  noResultsAdditionalMessage,
  keyword,
  showError,
  withDidYouMean
}: ErrorProps) {
  return (
    <div className="error-message">
      {showError ? (
        <div
          className="error-message__error rtf"
          dangerouslySetInnerHTML={{ __html: errorMessage }}
        />
      ) : (
        <>
          {keyword ? (
            <div className="error-message__error">
              {noResultsKeywordMessage.replace('{{KEYWORD}}', keyword)}
            </div>
          ) : (
            <div className="error-message__error">{noResultsMessage}</div>
          )}
          {withDidYouMean && <DidYouMean correctionOnly={true} />}
          {noResultsAdditionalMessage && (
            <div
              className="error-message__additional-message rtf"
              dangerouslySetInnerHTML={{ __html: noResultsAdditionalMessage }}
            />
          )}
        </>
      )}
    </div>
  );
}

export default Error;
